import { cn } from 'utils/classNames';

type Variant = 'dashing' | 'regular';
export type CircleSize = 'large' | 'medium' | 'small';
type CircleStrokeWidth = 'medium' | 'thick' | 'thin';
type TrackColor = 'grey' | 'julaRed' | 'transparent';
type SpinnerColor = 'dark' | 'grey' | 'julaRed';

interface Props {
	circleStrokeWith?: CircleStrokeWidth;
	className?: string;
	size?: CircleSize;
	spinnerColor?: SpinnerColor;
	trackColor?: TrackColor;
	variant?: Variant;
}

const STROKE_WIDTHS: Record<CircleStrokeWidth, string> = {
	thin: '1',
	medium: '3',
	thick: '6',
};

export default function LoadingSpinner({
	circleStrokeWith = 'medium',
	className,
	size = 'large',
	spinnerColor = 'julaRed',
	trackColor = 'transparent',
	variant = 'dashing',
}: Props) {
	return (
		<svg
			viewBox="25 25 50 50"
			className={cn(
				'animate-spinnerRotate',
				className,
				size === 'small' && 'size-16',
				size === 'medium' && 'size-28',
				size === 'large' && 'size-40',
			)}
		>
			<circle
				cx="50"
				cy="50"
				fill="none"
				r="20"
				strokeWidth={STROKE_WIDTHS[circleStrokeWith]}
				stroke="currentColor"
				strokeLinecap="round"
				className={cn(
					trackColor === 'julaRed' && 'text-brand',
					trackColor === 'grey' && 'text-[#BBB]',
					trackColor === 'transparent' && 'text-transparent',
				)}
			/>
			<circle
				cx="50"
				cy="50"
				r="20"
				fill="none"
				strokeWidth={STROKE_WIDTHS[circleStrokeWith]}
				strokeMiterlimit="10"
				strokeDasharray={variant === 'dashing' ? '1px, 200px' : '40px, 400px'}
				strokeDashoffset="0px"
				stroke="currentColor"
				strokeLinecap={variant === 'dashing' ? 'round' : 'square'}
				className={cn(
					variant === 'dashing' && 'animate-spinnerDash',
					spinnerColor === 'julaRed' && 'text-brand',
					spinnerColor === 'grey' && 'text-[#BBB]',
					spinnerColor === 'dark' && 'text-base',
				)}
			/>
		</svg>
	);
}

LoadingSpinner.displayName = 'LoadingSpinner';
